import React, { useState, useEffect } from "react";
import "./knowledgeBaseUpload.css";
import { Upload, FileText, Play, Logs, Zap, Wand2, Trash2 } from "lucide-react";
import PageTitle from "../../../Module/pageTitle";
import {
  getExamListNew,
  getParentCourseNew,
} from "../../../Action/courseAction";
import {
  addBooksknowledge,
  addStoreKnowledgeBaseAIData,
  getAIPrompt,
  getAllBooks,
  updateTextData,
  uploadAiJsonFiles,
  uploadImageZipFolder,
} from "../../../Action/adminPanelAction";
import { useDispatch } from "react-redux";
import Dropdown from "../../../Component/dropdown";
import * as pdfjs from "pdfjs-dist";
import LabelField from "../../../Component/labelField";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ExamNamePopUp from "../../../Component/examNamePopUp";
import ExamAndSubExamPopUp from "../../../Component/ExamAndSubExamPopUp";
import { Chip } from "@mui/material";
import { updateValues } from "../../../Action/authAction";
// pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.4.168/pdf.worker.min.js`;

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

const supportedFormats = [
  "ZIP",
  // "DOC/DOCX",
  // "PPT/PPTX",
  // "MP4/MOV",
  // "MP3/WAV",
  // "JPG/PNG",
  // "URL",
];

const CropImageZipUpload = () => {
  const dispatch = useDispatch();
  const [exam, setExam] = useState("");
  const [subExam, setSubExam] = useState("");
  const [examStream, setExamStream] = useState("");
  const [dragActive, setDragActive] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [initialPromptPayload, setInitialPromptPayload] = useState("");
  const [nextPromptPayload, setNextPromptPayload] = useState("");
  const [responseFromPrompt, setResponseFromPrompt] = useState("");
  const [command, setCommand] = useState("");
  const [finalResponseFromOutput, setFinalResponseFromPrompt] = useState("");
  const [results, setResults] = useState([]);
  const [finalText, setFinalText] = useState("");

  const [selectedExamList, setSelectedExamList] = useState([]);
  const [examOpen, setExamOpen] = useState(false);
  const [bookDetailsList, setBookDetailsList] = useState([]);
  const [selectedBook, setSelectedBook] = useState("");

  useEffect(() => {
    dispatch(
      getAllBooks({ isTextUploaded: true }, (res) => {
        // const result = res.map(({ bookName, ...rest }) => ({
        //   ...rest,
        //   name: bookName,
        // }));
        setBookDetailsList(res);
      }),
    );
  }, []);
console.log("selectedBook",bookDetailsList)
  // Handle drag and drop
  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      formUploadPayload(fileArray);
    }
  };

  const handleFileInput = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      formUploadPayload(fileArray);
    }
  };

  const formUploadPayload = (fileArray) => {
    const newFiles = fileArray.map((file) => {
      let fileType = "other";

      if (file.type.startsWith("image/")) {
        fileType = "image";
      } else if (file.type === "application/pdf") {
        fileType = "document";
      } else {
        fileType = "other";
      }

      return {
        // subject: subject?.name || "",
        name: file.name,
        size: (file.size / 1024 / 1024).toFixed(2),
        fileType: fileType,
        file: file,
        type: file.type,
        progress: 0,
        timestamp: new Date().toLocaleString(),
      };
    });

    setUploadedFiles((prev) => [...prev, ...newFiles]);
  };

  const handleRemoveFile = (index) => {
    setUploadedFiles(uploadedFiles.filter((_, i) => i !== index));
  };

  const uploadFilePromise = (file) => {
    return new Promise((resolve, reject) => {
      dispatch(
        uploadImageZipFolder(file, (res) => {
          if (res) {
            resolve(res);
          } else {
            reject("Upload failed");
          }
        }),
      );
    });
  };

  const handleUplodFiles = async () => {
    for (let index = 0; index < uploadedFiles.length; index++) {
      const item = uploadedFiles[index];

      // ← changed condition: check for zip
      if (
        item?.file?.type === "application/zip" ||
        item?.file?.name?.endsWith(".zip")
      ) {
        setUploadedFiles((prev) => {
          const updated = [...prev];
          updated[index] = { ...updated[index], progress: 50 };
          return updated;
        });

        try {
          const res = await uploadFilePromise(item?.file);

          setUploadedFiles((prev) => {
            const updated = [...prev];
            updated[index] = {
              ...updated[index],
              bookUrl: res.fileUrl,
              progress: 100,
            };
            return updated;
          });

          const output = selectedExamList.map(({ examId, baseCourseId }) => ({
            examTypeId: examId,
            baseCourseId,
          }));

          const bookNameWithoutExtension = uploadedFiles[0]?.name.replace(
            /\.[^/.]+$/,
            "",
          );

          if (selectedBook) {
            const postData = {
              exams: output,
              images: res.data,
              bookUrl: selectedBook.bookUrl,
              // bookName: selectedBook?.name,
              isTextUploaded: true,
              isImageUploaded:true
            };
            dispatch(
              updateTextData(selectedBook?._id, postData, (res) => {
                console.log("addBooksknowledge", res);
                setSelectedExamList([]);
                setUploadedFiles([]);
                setExam("");
                setSubExam("");
                setExamStream("");
              }),
            );
          } else {
            const postData = {
              exams: output,
              images: res.data,
              bookName: bookNameWithoutExtension,
              isTextUploaded: false,
              isImageUploaded:true
            };

            dispatch(
              addBooksknowledge(postData, (res) => {
                setSelectedExamList([]);
                setUploadedFiles([]);
                setExam("");
                setSubExam("");
                setExamStream("");
              }),
            );
          }
        } catch (err) {
          setUploadedFiles((prev) => {
            const updated = [...prev];
            updated[index] = { ...updated[index], progress: 0, error: true };
            return updated;
          });
        }
      }
    }
  };

  const handleTrashClick = () => {
    setCommand("");
  };

  const handleExecuteCommand = () => {
    if (!command.trim()) {
      return;
    }
    const postData = {
      type: "text",
      text: command,
    };

    let tempPayload = [...initialPromptPayload, postData];

    setNextPromptPayload(tempPayload);
    dispatch(updateValues("loader", true));
    dispatch(
      getAIPrompt({ prompt: tempPayload }, (res) => {
        dispatch(updateValues("loader", false));
        const text =
          res?.content?.[0]?.text ||
          res?.data?.output ||
          res?.output ||
          res?.message ||
          res ||
          "";
        setResponseFromPrompt(text);
      }),
    );
  };

  const handleExtractDataToJSON = () => {
    const subExamField = subExam ? `"subExamTypeId": "${subExam._id}",\n` : "";

    let lastPromptText = `
    You are a JSON generator.

    Return ONLY a valid JSON object.
    Do NOT return a string.
    Do NOT wrap JSON in quotes.
    Do NOT include markdown, code blocks, or explanations.

    STRICT RULES:
    - Output must start with { and end with }
    - JSON must be valid and parseable
    - No trailing commas
    - No extra text before or after JSON
    - Use double quotes for all keys and values

    OPTIMIZATION RULES:
    - Include baseCourseId and examTypeId ONLY at root level, id should be the same which I shared in prompt dont change that values
    - Do NOT repeat them inside subjects, topics, or subTopics

    STRUCTURE:

    {
      "jsonData" : {
        "baseCourseId": "${examStream?._id}",
        "examTypeId": "${exam?._id}",
        ${subExamField}
        
        "subjects": [
          {
            "name": "",
            "order": 1,
            "topics": [
              {
                "name": "",
                "order": 1,
                "subTopics": [
                  {
                    "name": "",
                    "lectures": [
                      {
                        "name": "",
                        "lectureDescription": ""
                      }
                    ]
                  },
                ]
              }
            ]
          }
        ]
      }

      "pattern" : {
        "isOwnTest": false,
        "baseCourseId": "${examStream?._id}",
        "examTypeId": "${exam?._id}",
        ${subExamField}
        "totalQuestions": 0,
        "isModelSet": true,
        "sectionData": [
            {
              "isCompulsory": false,
              "name": "",
              "totalQuestions": 0,
              "maxAttempt": 0,
              "parts": [
                  {
                    "questionType": 0,
                    "questionFrom": 0,
                    "questionTo": 0,
                    "totalQuestions": 0,
                    "correct": 0,
                    "negative": 0
                  },
                ]
            }
          ],
        "name": "",
        "description": "",
        "calcType": 1,
        "display": false
      }
    }

    FINAL INSTRUCTION:
    Return ONLY raw JSON object file dont want single string value. No string. No explanation. No markdown. Don't Change json structure.
    `;
    if (!lastPromptText.trim()) {
      return;
    }

    const postData = {
      type: "text",
      text: lastPromptText,
    };
    let tempPayload = [];
    if (command === "") {
      tempPayload = [...initialPromptPayload, postData];
    } else {
      tempPayload = [...nextPromptPayload, postData];
    }
    dispatch(updateValues("loader", true));
    dispatch(
      getAIPrompt({ prompt: tempPayload }, (res) => {
        dispatch(updateValues("loader", false));
        const text =
          res?.content?.[0]?.text ||
          res?.data?.output ||
          res?.output ||
          res?.message ||
          res ||
          "";
        let typeFile = typeof text;
        let result;
        if (typeFile === "string") {
          setFinalResponseFromPrompt(text);
          const rawText = text
            .trim()
            .replace(/^```json\s*/i, "") // strip opening ```json
            .replace(/^```\s*/i, "") // strip opening ```
            .replace(/```\s*$/i, ""); // strip closing ```

          try {
            result = JSON.parse(rawText);
          } catch (e) {
            console.error("JSON parse failed:", e);
            return; // stop here so you can debug
          }
        } else if (typeFile === "object") {
          result = text;
        }

        const jsonString = JSON.stringify(result, null, 2);

        const jsonFile = new File([jsonString], `output_${Date.now()}.json`, {
          type: "application/json",
        });

        dispatch(
          uploadAiJsonFiles(jsonFile, (jsonRes) => {
            if (jsonRes) {
              let postData = {
                examTypeId: exam?._id,
                baseCourseId: examStream?._id,
                fileUrl: jsonRes?.fileUrl,
              };
              if (subExam) {
                postData["subExamTypeId"] = subExam?._id;
              }
              dispatch(addStoreKnowledgeBaseAIData(postData, (finalRes) => {}));
            }
          }),
        );
      }),
    );
  };

  const ClaudeResponse = () => {
    const text = responseFromPrompt;
    return (
      // <div className="claude-response">
      //   <ReactMarkdown>{text}</ReactMarkdown>
      // </div>

      <div style={{ marginTop: 10 }}>
        <div
          style={{
            background: "#ffffff",
            border: "1px solid #e2e8f0",
            borderRadius: "8px",
            padding: "24px",
            lineHeight: "1.8",
            fontSize: "15px",
            maxWidth: "800px",
          }}
        >
          {renderFinalText(finalText)}
        </div>
      </div>
    );
  };

  const renderFinalText = (text) => {
    if (!text) return null;

    // Split text by S3 URLs
    const parts = text.split(
      /(https:\/\/[^\s]+\.amazonaws\.com\/[^\s]+\.(png|jpg|jpeg|webp))/gi,
    );

    return parts.map((part, index) => {
      // Check if this part is an S3 URL
      const isS3Url =
        part.startsWith("https://") &&
        part.includes(".amazonaws.com") &&
        (part.endsWith(".png") ||
          part.endsWith(".jpg") ||
          part.endsWith(".jpeg") ||
          part.endsWith(".webp"));

      if (isS3Url) {
        // ✅ Render as image
        return (
          <div
            key={index}
            style={{
              margin: "20px 0",
              textAlign: "center",
            }}
          >
            <img
              src={part}
              alt={`diagram-${index}`}
              style={{
                maxWidth: "100%",
                height: "auto",
                border: "1px solid #e2e8f0",
                borderRadius: "8px",
                display: "inline-block",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              }}
            />
          </div>
        );
      }

      // ✅ Render as text
      return (
        <span key={index} style={{ whiteSpace: "pre-wrap" }}>
          {part}
        </span>
      );
    });
  };

  const onChangeBook = (value) => {
    const result = value?.exams?.map(({ examTypeId, _id, ...rest }) => ({
      examId: examTypeId,
      ...rest,
    }));
    setSelectedExamList(result || []);
    setSelectedBook(value);
  };
  const handleDelet = ({
    examId = null,
    subExamId = null,
    baseCourseId = null,
  }) => {
    setSelectedExamList((prev) => {
      let updated = prev.filter((item) => {
        if (examId && baseCourseId) {
          return !(
            String(item.examId) === String(examId) &&
            String(item.baseCourseId) === String(baseCourseId)
          );
        }

        if (examId && subExamId && !baseCourseId) {
          return !(
            String(item.examId) === String(examId) &&
            String(item.subExamId) === String(subExamId)
          );
        }

        if (examId && !subExamId && !baseCourseId) {
          return String(item.examId) !== String(examId);
        }

        return true;
      });

      return updated;
    });
  };
  return (
    <div className="contentBox">
      <PageTitle name={"Book Zip File Upload"} />
      <div className="formDiv contentScrollbar">
        <div className="knowledge-upload-container d-flex justify-content-center">
          {/* Main Content */}
          <div className="col-md-6">
            {/* Left Section - Upload */}
            <div className="upload-section">
              {/* Upload Materials Card */}
              <div className="upload-card">
                <div className="card-header-KB">
                  <FileText size={20} />
                  <h2>Upload Materials</h2>
                  <button className="format-btn">All Formats</button>
                </div>

                <div className="upload-form">
                  <div className="">
                    {/* Exam Selection */}
                    <div className="form-field-AI">
                      <label htmlFor="exam">
                        Choose a book (if texts are already uploaded)
                      </label>
                      <Dropdown
                        labelName="Select Book Name"
                        setInputText={(value) => onChangeBook(value)}
                        options={bookDetailsList}
                        value={selectedBook}
                      />
                    </div>
                  </div>
                  {/* Exam Selection */}
                  <div className="mb-2">
                    <div className="fw-semibold mb-2">
                      Exam Name <span className="text-danger">*</span>
                    </div>

                    <div className="d-flex flex-wrap gap-2">
                      {[
                        ...new Map(
                          selectedExamList.map((item) => [item.examId, item]),
                        ).values(),
                      ].map((exam) => (
                        <div
                          key={exam.examId}
                          className="d-flex align-items-center bg-light border rounded-pill px-3 py-1"
                        >
                          <span className="small fw-medium font10">
                            {exam.examName}
                          </span>

                          <span
                            className="ms-2 text-danger cursor-pointer font10"
                            onClick={() => handleDelet({ examId: exam.examId })}
                          >
                            ✕
                          </span>
                        </div>
                      ))}
                    </div>

                    <Chip
                      variant="outlined"
                      color="primary"
                      size="small"
                      label="View Exams"
                      icon={<RemoveRedEyeIcon fontSize="small" />}
                      onClick={() => setExamOpen(true)}
                      sx={{
                        cursor: "pointer",
                        fontWeight: 500,
                        px: 1,
                        mt: 1,
                        "&:hover": {
                          backgroundColor: "#f5f5f5",
                        },
                      }}
                    />
                  </div>
                  {selectedExamList.some((e) => e.subExamName) && (
                    <div className="mb-2">
                      <div className="fw-semibold mb-2">
                        Sub Exam Type <span className="text-danger">*</span>
                      </div>

                      <div className="d-flex flex-wrap gap-2">
                        {[
                          ...new Map(
                            selectedExamList.map((item) => [
                              item.subExamId,
                              item,
                            ]),
                          ).values(),
                        ].map((exam) => (
                          <div
                            key={exam.subExamId}
                            className="d-flex align-items-center bg-light border rounded-pill px-3 py-1"
                          >
                            <span className="small font10">
                              {exam.subExamName}
                            </span>

                            <span
                              className="ms-2 text-danger cursor-pointer font10"
                              onClick={() =>
                                handleDelet({
                                  examId: exam.examId,
                                  subExamId: exam.subExamId,
                                })
                              }
                            >
                              ✕
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {selectedExamList.length > 0 && (
                    <div className="mb-2">
                      <div className="fw-semibold mb-2">
                        Exam Stream <span className="text-danger">*</span>
                      </div>

                      <div className="d-flex flex-wrap gap-2">
                        {selectedExamList.map((exam) => (
                          <div
                            key={`${exam.baseCourseId}-${exam.subExamId || "base"}`}
                            className="d-flex align-items-center bg-white border rounded-pill px-3 py-1 shadow-sm"
                          >
                            <span className="small font10">
                              {exam.subExamName
                                ? `${exam.subExamName} - ${exam.baseCourseName}`
                                : `${exam.examName} - ${exam.baseCourseName}`}
                            </span>

                            <span
                              className="ms-2 text-danger cursor-pointer font10"
                              onClick={() =>
                                handleDelet({
                                  examId: exam.examId,
                                  baseCourseId: exam.baseCourseId,
                                  subExamId: exam.subExamId,
                                })
                              }
                            >
                              ✕
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Drag and Drop Area */}
                  <label
                    className={`drag-drop-area ${dragActive ? "active" : ""}`}
                    onDragEnter={handleDrag}
                    onDragLeave={handleDrag}
                    onDragOver={handleDrag}
                    onDrop={handleDrop}
                  >
                    <Upload size={48} className="upload-icon" />
                    <h3>Drop files here or click to browse</h3>
                    <p>Supports all major formats</p>
                    <div className="format-badges">
                      {supportedFormats.map((format) => (
                        <span key={format} className="format-badge">
                          {format}
                        </span>
                      ))}
                    </div>
                    <input
                      type="file"
                      multiple
                      onChange={(e) => handleFileInput(e)}
                      className="file-input"
                      accept=".zip"
                    />
                  </label>
                </div>

                {/* Upload Queue */}
                {handleUplodFiles.length > 0 && (
                  <div className="upload-queue">
                    <h3>Upload Queue</h3>
                    <div className="queue-count">
                      {uploadedFiles.length} files
                    </div>

                    {uploadedFiles.length === 0 ? (
                      <div className="no-files">No files uploaded yet</div>
                    ) : (
                      <div className="files-list">
                        {uploadedFiles.map((file, index) => (
                          <div key={index} className="file-item">
                            <div className="file-row">
                              <div className="file-info">
                                <FileText size={16} />
                                <div className="file-details">
                                  <p className="file-name fw-bold">
                                    {file.subject}
                                  </p>
                                  <p className="file-name">{file.name}</p>
                                  <p className="file-meta mb-0">
                                    {file.size} MB • {file.timestamp}
                                  </p>
                                </div>
                              </div>
                              <button
                                className="remove-btn"
                                onClick={() => handleRemoveFile(index)}
                                title="Remove file"
                              >
                                ✕
                              </button>
                            </div>
                            <div className="file-progress">
                              <div
                                className="progress"
                                role="progressbar"
                                // aria-label="Example 1px high"
                                aria-valuenow={file.progress || 0}
                                aria-valuemin="0"
                                aria-valuemax="100"
                                style={{ height: "2px" }}
                              >
                                <div
                                  className="progress-bar"
                                  style={{ width: `${file.progress || 0}%` }}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
                <div className="config-form">
                  <button
                    className="start-btn"
                    onClick={handleUplodFiles}
                    disabled={
                      uploadedFiles.length === 0 ||
                      selectedExamList.length === 0
                    }
                  >
                    <Upload size={18} />
                    <span>Upload Files</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {examOpen && (
        <ExamAndSubExamPopUp
          open={examOpen}
          handleClose={() => setExamOpen(false)}
          selectedList={selectedExamList}
          onSelectExams={(data) => setSelectedExamList(data)}
        />
      )}
    </div>
  );
};

export default CropImageZipUpload;
